import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import './styles/globals.css';

// 全局导入Typography以确保它在任何地方都可用
import { Typography } from 'antd';
// 将Typography添加到全局window对象
(window as any).Typography = Typography;

// 创建React Query客户端
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

// 获取根元素
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('未找到 root 元素');
}

// 创建并渲染 React 应用
const reactRoot = createRoot(rootElement);

reactRoot.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <App />
      </Router>
    </QueryClientProvider>
  </React.StrictMode>
); 